import { useAtomValue } from "jotai";
import type { MouseEvent } from "react";
import { widgetMenuOptionsByNameAtom } from "@/interface/AppStore";
import type { widgetOption } from "@/widgetMenu/widgetMenu";
import { LINE_TYPES } from "../../constants/lineTypes";
import type {
    ActiveSubMenuState,
    LineOption,
    MenuOptionResult,
    SetActiveSubMenu,
} from "../../types";

interface UseLineTypeButtonProps {
    activeSubMenu: ActiveSubMenuState | null;
    setActiveSubMenu: SetActiveSubMenu;
}

export function useLineTypeButton({
    activeSubMenu,
    setActiveSubMenu,
}: UseLineTypeButtonProps): MenuOptionResult {
    const options = useAtomValue(
        widgetMenuOptionsByNameAtom("lineType"),
    ) as widgetOption<LineOption>[];

    const uniqueValues = [...new Set(options.map((option) => option.value))];

    const Icon = LINE_TYPES[uniqueValues[0].lineType];

    const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
        const button = event.currentTarget;

        setActiveSubMenu((prev) =>
            prev?.name === "lineType" ? null : { name: "lineType", anchor: button },
        );
    };

    const content = <Icon />;

    const isActive = activeSubMenu?.name === "lineType";

    return {
        content,
        handleClick,
        isActive,
    };
}
